export default __webpack_public_path__ + "static/media/cvod-RP15.94b299f2.svg";